import { configureStore } from '@reduxjs/toolkit'
import dataReducer from './features/dataFormSlice'
export const store = configureStore({
  reducer: {
    data: dataReducer
  },
})